import { FC, ReactElement, ReactNode } from "react";
import { Link } from "../../../navigation";

export interface IslandItemProps
  extends Omit<React.ComponentPropsWithoutRef<"a">, "href"> {
  children: ReactNode;
  active?: boolean;
  disabled?: boolean;
  href: any;
  LinkComponent?: any;
  shallow?: boolean;
  scroll?: boolean;
}

export interface IslandProps extends React.ComponentPropsWithoutRef<"div"> {
  children: ReactElement<IslandItemProps> | ReactElement<IslandItemProps>[];
}

export const IslandItem = function IslandItem({
  children,
  className,
  active,
  LinkComponent = "a",
  ...rest
}: IslandItemProps) {
  return (
    <LinkComponent
      className={className || "unchained-island__item"}
      // tabIndex={active ? 0 : -1}
      aria-selected={active || false}
      role="tab"
      aria-disabled={!!rest?.disabled}
      {...rest}
    >
      {children}
    </LinkComponent>
  );
};

const Island: FC<IslandProps> & { Item: typeof IslandItem } = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div className={className || "unchained-island"} role="tablist" {...rest}>
      {children}
    </div>
  );
};

Island.Item = IslandItem;

export default Island;
